<template>
  <div>
    <AppHeader />
    <div class="detail-bg"></div>
    <div class="container">
      <div class="page-header">
        <div class="icon-bar back" @click="handleBack"></div>
        <div class="page-title sub">{{ $t('add.text25') }}</div>
      </div>
      <div class="detail-box">
        <div class="list8">
          <div class="item">
            <div class="tit up">{{ $t('add.method') }} 1</div>
            <div class="de">
              {{ $t('add.text26') }}
            </div>
            <div class="icon-block type3">
              <a
                class="icon email"
                href="mailto:info@krazefootball.com"
                target="_blank"
                >{{ $t('add.email') }}</a
              >
              <a
                class="icon telegram"
                href="https://t.me/krazeglobebot"
                target="_blank"
                >{{ $t('add.telegram') }}</a
              >
              <a
                class="icon facebook2"
                href="https://www.facebook.com/Kraze-Football-110505258463937/"
                target="_blank"
                >{{ $t('add.facebook') }}</a
              >
            </div>
          </div>
          <div class="item">
            <div class="tit up">{{ $t('add.method') }} 2</div>
            <div class="de">{{ $t('add.text27') }}</div>
            <coinCharge
              style="margin: 0.18rem 0 0.1rem"
              ref="coinCharge"
              v-bind:callback-url="callbackUrl"
              v-bind:usdt="
                modelForm.web5_score / $store.state.homeConfig.recharge_ratio
              "
              class="el-button--white2"
              title="Deposit"></coinCharge>
          </div>
          <div class="item">
            <div class="tit up">{{ $t('add.method') }} 3</div>
            <div class="de al">1.{{ $t('add.text30') }}</div>
            <div class="icon-block type4">
              <a
                href="https://satoshi7988.myshopify.com/"
                target="_blank"
                class="icon shopify"
                >{{ $t('add.shopify') }}</a
              >
              <div class="dess al" v-html="$t('add.text96')"></div>
            </div>
            <div class="de al">2.{{ $t('add.text28') }}</div>
            <el-form
              :model="modelForm2"
              ref="modelForm2"
              label-width="0"
              style="margin-top: 0.18rem; text-align: left"
              :inline="true">
              <el-form-item
                prop="cdkey"
                :rules="[
                  {
                    required: true,
                    message: this.$t('add.text29'),
                    trigger: 'blur'
                  }
                ]">
                <el-input
                  style="width: 2.1rem"
                  v-model="modelForm2.cdkey"></el-input>
              </el-form-item>
              <el-form-item style="margin-right: 0">
                <el-button
                  class="el-button--white3"
                  style="width: 0.65rem"
                  @click="submitForm('modelForm2')">
                  {{ $t('add.recharge') }}
                </el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <mt-popup
      v-model="popupVisible"
      position="bottom"
      :closeOnClickModal="false">
      <!-- <div class="pop-box deposit" v-if="popType === 'deposit'">
        <div class="pop-title" style="margin-bottom: 0.38rem">
          {{ $t('accountpage.text8') }}
        </div>
        <el-form
          :model="modelForm"
          status-icon
          ref="modelForm"
          label-width="100px"
          label-position="top">
          <el-form-item
            prop="num"
            :label="$t('add.text32')"
            :rules="[
              {
                required: true,
                message: this.$t('add.text29'),
                trigger: 'blur'
              }
            ]">
            <el-input v-model="modelForm.web5_score"></el-input>
          </el-form-item>
          <el-form-item
            prop="type"
            :label="$t('add.text31')"
            :rules="[
              {
                required: true,
                message: this.$t('add.text29'),
                trigger: 'blur'
              }
            ]">
            <el-input
              v-bind:value="
                modelForm.web5_score / $store.state.homeConfig.recharge_ratio
              "></el-input>
          </el-form-item>
          <coinCharge
            ref="coinCharge"
            v-bind:callback-url="callbackUrl"
            v-bind:usdt="
              modelForm.web5_score / $store.state.homeConfig.recharge_ratio
            "
            class="block el-button--special link_btn"
            title="Deposit"></coinCharge>
        </el-form>
      </div> -->
      <div class="pop-box buy" v-if="popType === 'success'">
        <div class="pop-title">{{ $t('accountpage.text8') }}</div>
        <div class="result-box">
          <div class="h icons success2">{{ $t('accountpage.text9') }}</div>
        </div>
        <el-button
          class="el-button--special block"
          style="margin-top: 0.55rem"
          @click="
            () => {
              this.popupVisible = false
            }
          "
          >{{ $t('completed') }}</el-button
        >
      </div>
      <div class="pop-box buy" v-if="popType === 'success2'">
        <div class="pop-title">{{ $t('accountpage.text8') }}</div>
        <div class="result-box">
          <div class="h icons success">{{ $t('accountpage.text9') }}</div>
          <div class="des">
            {{ $t('new.text69') }}
          </div>
        </div>
        <el-button
          class="el-button--white block"
          style="margin-top: 0.55rem"
          @click="
            () => {
              this.popupVisible = false
            }
          "
          >{{ $t('ok') }}</el-button
        >
      </div>
      <div class="pop-box buy" v-if="popType === 'fail'">
        <div class="pop-title">{{ $t('accountpage.text8') }}</div>
        <div class="result-box">
          <div class="h icons warning">{{ $t('new.text70') }}</div>
          <div class="des">
            {{ $t('new.text71') }}
          </div>
        </div>
        <el-button
          class="el-button--white block"
          style="margin-top: 0.55rem"
          @click="
            () => {
              this.popupVisible = false
            }
          "
          >{{ $t('ok') }}</el-button
        >
      </div>
      <div
        class="pop-close"
        @click="
          () => {
            this.popupVisible = false
          }
        "></div>
    </mt-popup>
  </div>
</template>
<script>
import { postCdkeyExchange } from '@/api/user'
import CoinCharge from '@/components/CoinCharge'

export default {
  name: 'UserUsdtNo',
  components: {
    CoinCharge
  },
  data() {
    return {
      list: null,
      modelForm: {
        web5_score: 0
      },
      modelForm2: {
        cdkey: ''
      },
      popupVisible: false,
      popType: null,
      callbackUrl: window.location.href
    }
  },
  created() {},
  mounted() {
    if (localStorage.web5_score) {
      this.modelForm.web5_score = localStorage.web5_score
    }
  },
  methods: {
    handleBack() {
      this.$router.back()
    },
    submitForm(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          postCdkeyExchange(this[form])
            .then((res) => {
              this.popType = 'success2'
              this.$refs[form].resetFields()
              this.popupVisible = true
            })
            .catch(() => {
              this.popType = 'fail'
              this.popupVisible = true
            })
        }
      })
    }
  }
}
</script>

<style lang="scss">
.link_btn {
  display: block;
  width: 100%;
  font-size: 0.16rem;
  font-weight: 500;
  text-transform: uppercase;
  height: 0.4rem;
  line-height: 0.4rem;
  padding: 0 0.16rem;
  font-family: 'Roboto Condensed';
  text-align: center;
  text-decoration: none;
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/views/user/usdtno.vue